    
export const BaseURL = `https://misbar-back.point-dev.net/`


export const BaseURL_IMAGE = BaseURL.slice(0,-1);
const PROJECT_NAME = "PROJECT_NAME"
export const TOKEN_KEY = PROJECT_NAME +  "_TOKEN"
export const USER_KEY =  PROJECT_NAME + "_USER"

